<template>
    <div id="app">
        <pageLoader :showLoader = 'showLoader' :listenToPageLoadState="true"></pageLoader>
        <div class="error_modal" v-if="messageModalModel">
            <div @click="messageModalModel = null" class="close">
                <img alt="Close" src="@/assets/icons/ic_close_white.svg">
            </div>
            <div class="body">{{messageModalModel.text}}</div>
        </div>

        <main id="page-wrap">
            <router-view/>
        </main>
    </div>
</template>

<script>
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    import '@/assets/css/buttons.css'
    import '@/assets/css/popupModal.css'

    import Vue from 'vue'
    import GAuth from 'vue-google-oauth2'
    import {VFBLogin as VFacebookLogin} from 'vue-facebook-login-component'

    import axios from 'axios';
    import api from '@/api';
    import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
    import navMixin from '@/mixins/navMixin';
    import config from '@/api/config';
    import pageLoader from "@/components/widgets/pageLoader";

    const gauthOption = {
        clientId: '476870467397-vdhi2d5l3sn458mesgpvrg47cugdjgbf.apps.googleusercontent.com',
        scope: 'profile email',
        prompt: 'select_account'
    };

    Vue.use(GAuth, gauthOption)

    export default {
        name: 'app',

        data() {
            return {
                messageModalModel: null,
                customModalSettings: {},
                loaderTags: [],
                showLoader: false,
            }
        },
        computed: {
            ...mapState({
                accessToken: state => state.auth.accessToken,
                messageModel: state => state.messageModel,
                loaderBarTag: state => state.progressBarTag,
            })
        },
        watch: {
            messageModel(item) {
                this.showMessageModal(item)
            },
            loaderBarTag(tag) {
                this.showProgressBar(tag)
            }
        },
        components: {pageLoader},

        async mounted() {

        },

        methods: {
            ...mapActions({

            }),

            showMessageModal(item) {
                let time = new Date().getMilliseconds()
                let duration = item.duration || 1500
                this.messageModalModel = {
                    text: item.msg,
                    displayed: time,
                }
                if (duration > 0) {
                    this.messageModalModel.timer = setTimeout(() => {
                        if (this.messageModalModel && this.messageModalModel.displayed === time) {
                            this.messageModalModel = null
                        }
                    }, duration)
                }
            },

            showProgressBar(data) {
                if (data.show) {
                    this.loaderTags.push(data.tag)
                } else {
                    this.loaderTags = this.loaderTags.filter(item => item != data.tag)
                }
                this.showLoader = this.loaderTags.length > 0
            },
        }

    }

    window.mixin = {
        mixins: [navMixin],
        data() {
            return {
                domain: '',
                checkTextAreaRowsValue: '',
                loadingFacebookSpinner: false
            }
        },
        components: {
            VFacebookLogin,
        },

        computed: {
            ...mapState({
                userInfo: state => state.auth.userInfo
            }),

            ...mapGetters({
                isUserClient: 'auth/isUserClient',
                isUserOwner: 'auth/isUserOwner',
                isUserAdmin: 'auth/isUserAdmin',
                isUserOrgManager: 'auth/isUserOrgManager',
                isUserSiteManager: 'auth/isUserSiteManager',
            }),
        },

        mounted() {

            let isRefreshing = false;
            var refreshReq = ""
            let subscribers = [];
            let refreshErrorSubscribers = [];

            function subscribeTokenRefresh(cb) {
                subscribers.push(cb);
            }

            function onRrefreshed(token, isAnon) {
                subscribers.map(cb => cb(token, isAnon));
            }

            axios.interceptors.response.use(
                (response) => {
                    return response;
                },
                (error) => {
                    const originalRequest = error.config;
                    console.info('INTRECEPT axios.interceptors.response. error.url:' + originalRequest.url);
                    if (error.response.status === 403 && !isRefreshing) {
                        isRefreshing = true;
                        console.info('INTRECEPT isRefreshing = true');
                        if (!localStorage.getItem('refresh_token')) {
                            console.info('refresh_token not found');
                            if (localStorage.getItem('guid')) {
                                console.info('guid found');
                                refreshReq = '/auth/sign-in'
                                api.request('post', '/auth/sign-in', {
                                    guid: localStorage.getItem('guid'),
                                })
                                    .then((response) => {
                                        console.log(response.data);
                                        console.info('INTRECEPT ANON SIGNIN success');

                                        this.saveAnonTokenData(response.data)
                                        refreshReq = ''
                                        isRefreshing = false;
                                        console.info('INTRECEPT isRefreshing = false');
                                        onRrefreshed(response.data.anonymous_token, true);
                                        subscribers = [];

                                        // originalRequest.headers.Authorization = 'Bearer ' + response.data.anonymous_token;
                                        // return axios(originalRequest);
                                    })
                                    .catch((error) => {
                                        console.info('INTRECEPT ANON SIGNIN ERROR');
                                        console.log(error);
                                        refreshReq = ''
                                        isRefreshing = false;
                                        refreshReq = '/auth/sign-up'
                                        api.request("post", '/auth/sign-up')
                                            .then((response) => {
                                                console.info('INTRECEPT ANON SIGNUP AFTER ANON SIGNIN ERROR 2 OK_NEW');
                                                console.log(response.data);

                                                this.saveAnonTokenData(response.data)
                                                refreshReq = ''
                                                isRefreshing = false;
                                                if (!originalRequest.url.includes('auth/')
                                                    && !originalRequest.url.includes('/questions') // api/v1/questions && api/questions
                                                    && !originalRequest.url.includes('users') // api/users /users
                                                ) {
                                                    console.info('INTRECEPT to sign-in url:' + originalRequest.url);
                                                    subscribers = [];
                                                    this.navToSignin()
                                                    return Promise.reject(error);
                                                }
                                                console.info('INTRECEPT isRefreshing = false');
                                                onRrefreshed(response.data.anonymous_token, true);
                                                subscribers = [];

                                                // originalRequest.headers.Authorization = 'Bearer ' + response.data.anonymous_token;
                                                // return axios(originalRequest);
                                            })
                                            .catch((error) => {
                                                onRrefreshed(null, null);
                                                refreshReq = ''
                                                isRefreshing = false;
                                                subscribers = [];
                                                console.info('INTRECEPT isRefreshing = false');
                                                console.info('INTRECEPT ANON SIGNUP AFTER ANON SIGNIN ERROR 2 ERROR');
                                                console.log(error);
                                            });
                                        console.info('INTRECEPT isRefreshing = false');
                                    });
                            } else {
                                console.info('guid not found');
                                refreshReq = '/auth/sign-up'
                                api.request("post", '/auth/sign-up')
                                    .then((response) => {
                                        console.info('INTRECEPT ANON SIGNUP OK_NEW');
                                        console.log(response.data);

                                        this.saveAnonTokenData(response.data)
                                        refreshReq = ''
                                        isRefreshing = false;
                                        console.info('INTRECEPT isRefreshing = false');
                                        onRrefreshed(response.data.anonymous_token, true);
                                        subscribers = [];
                                    })
                                    .catch((error) => {
                                        console.info('INTRECEPT ANON SIGNUP ERROR');
                                        console.log(error);
                                        onRrefreshed(null, null);
                                        refreshReq = ''
                                        isRefreshing = false;
                                        console.info('INTRECEPT isRefreshing = false');
                                    });
                            }
                        } else {
                            console.info(`refresh_token found  window.domain:${window.domain}`);
                            refreshReq = '/auth/refresh'
                            api.request("post", '/auth/refresh', {
                                token: localStorage.getItem('refresh_token'),
                            })
                                .then((response) => {
                                    console.info('REFRESH OK_NEW');
                                    console.info(response.data);
                                    if (response.data.access_token) {
                                        localStorage.setItem('access_token', response.data.access_token);
                                    }
                                    if (response.data.refresh_token) {
                                        localStorage.setItem('refresh_token', response.data.refresh_token);
                                        localStorage.setItem('user_guid', response.data.user_guid);
                                    }
                                    refreshReq = ''
                                    isRefreshing = false;
                                    console.info('INTRECEPT isRefreshing = false');
                                    onRrefreshed(response.data.access_token, false);
                                    subscribers = [];
                                })
                                .catch((error) => {
                                    console.info('/auth/refresh ERROR');
                                    console.log(error);
                                    this.$store.commit('auth/removeKeys')
                                    refreshReq = '/auth/sign-up'
                                    api.request("post", '/auth/sign-up')
                                        .then((response) => {
                                            console.info('INTRECEPT ANON SIGNUP 2 OK_NEW');
                                            console.log(response.data);

                                            this.saveAnonTokenData(response.data)
                                            refreshReq = ''
                                            isRefreshing = false;
                                            if (!originalRequest.url.includes('auth/')
                                                && !originalRequest.url.includes('/questions') // api/v1/questions && api/questions
                                                && !originalRequest.url.includes('users') // api/users /users
                                            ) {
                                                console.info('INTRECEPT to sign-in url:' + originalRequest.url);
                                                subscribers = [];
                                                this.navToSignin()
                                                return Promise.reject(error);
                                            }
                                            console.info('INTRECEPT isRefreshing = false');
                                            onRrefreshed(response.data.anonymous_token, true);
                                            subscribers = [];
                                        })
                                        .catch((error) => {
                                            onRrefreshed(null, null);
                                            refreshReq = ''
                                            isRefreshing = false;
                                            console.info('INTRECEPT isRefreshing = false');
                                            console.info('INTRECEPT ANON SIGNUP 2 ERROR');
                                            console.log(error);
                                        });
                                });
                        }
                    }
                    console.info(`INTRECEPT error.response.status === ${error.response.status} refreshReq:${refreshReq} url:${originalRequest.url}`);
                    if (error.response.status === 403 && isRefreshing) {
                        console.info('INTRECEPT error.response.status === 403 && isRefreshing');
                    }
                    if (originalRequest.url.includes(refreshReq)) {
                        return Promise.reject(error);
                    }
                    if (error.response.status === 403) {
                        return new Promise((resolve, reject) => {
                            subscribeTokenRefresh((token, isAnon) => {
                                console.info(`INTRECEPT subscribeTokenRefresh isAnon:${isAnon} token:${token}`);
                                if (token == null) {
                                    reject(new Error())
                                    return
                                } else if (isAnon) {
                                    if (originalRequest.url.includes('v1/')) {
                                        let oldUrl = originalRequest.url;
                                        originalRequest.url = originalRequest.url.replace('v1/', '');
                                        console.info(`INTRECEPT changedUrl old:${oldUrl} new: ${originalRequest.url}`);
                                    }
                                    if (originalRequest.url.includes('users/')) {
                                        reject(new Error())
                                        return
                                    }
                                }
                                originalRequest.headers.Authorization = `Bearer ${token}`;
                                resolve(axios(originalRequest));
                            });
                        });
                    }
                    return Promise.reject(error);
                }
            );

            if (localStorage.getItem('guid') == undefined || localStorage.getItem('anonymous_token') == undefined) {
                // this.signUpAnon();
            }


            // if (localStorage.getItem('access_token') && localStorage.getItem('user_guid')) {
            //     this.getUserInfo();
            // }
        },
        methods: {
            ...mapActions({
                signUpFaceBookAction: 'auth/signUpFaceBook',
                signUpGoogleAction: 'auth/signUpGoogle',
                fetchUserInfo: 'auth/fetchUserInfo',
                makeOwnerAction: 'owner/makeOwner',
                saveLog: 'auth/saveLog',
                sendLocationError: 'auth/sendLocationError',
                sendLocationAllowedPopup: 'auth/sendLocationAllowedPopup',
                sendGpsPopupAsked: 'auth/sendGpsPopupAsked',
                sendGpsRequested: 'auth/sendGpsRequested',
                sendVoteGeolocation: 'rate/sendVoteGeolocation',
                sendLocationIsOld: 'rate/sendLocationIsOld',
                sendGpsLoadingPopupHide: 'auth/sendGpsLoadingPopupHide',
            }),

            saveAnonTokenData(data) {
                this.saveLog(`saveAnonTokenData called data: ${JSON.stringify(data)}`)
                localStorage.setItem("guid", data.guid);
                localStorage.setItem("anonymous_token", data.anonymous_token);
                this.$store.commit('auth/setAnonymousToken', {
                    token: data.anonymous_token,
                    guid: data.guid
                })
            },

            async getUserInfo() {
                await this.fetchUserInfo()
            },

            setSignInState(response) {
                this.saveLog(`setSignInState -> resetAnonymousToken`)
                this.$store.commit('auth/resetAnonymousToken')
                this.$store.commit('auth/setUser', response.data.user_guid)
                this.$store.commit('auth/setAccessToken', {
                    accessToken: response.data.access_token,
                    refreshToken: response.data.refresh_token
                })
            },
            async tryChangeUserStatus() {
                await this.fetchUserInfo()
                console.log(`zzz this.isUserClient:${this.isUserClient} this.isUserOrgManager:${this.isUserOrgManager} this.isUserSiteManager:${this.isUserSiteManager}`)
                if (this.isUserClient && !this.isUserOrgManager && !this.isUserSiteManager) {
                    await this.makeOwner()
                    await this.fetchUserInfo()
                } else if (this.isUserOwner) {
                    if (this.userInfo.organization) {
                        if (!this.userInfo.organization.place) {
                            this.$store.commit('owner/setOwner', true)
                        }
                    } else {
                        await this.makeOwner()
                        await this.fetchUserInfo()
                    }
                }
            },
            async makeOwner() {
                try {
                    const response = await this.makeOwnerAction();
                    if (response.data.success) {
                        this.$store.commit('owner/setOwner', true)
                        this.$router.push({name: 'Login'});
                    }
                } catch (error) {
                    if (error.status == 400) {
                        if (error.data.error.code == 1113) {
                            this.$store.commit('owner/setOwner', true)
                            this.$router.push({name: 'Login'});
                        } else if (error.data.success == false) {
                            this.$store.commit('owner/setOwner', false)
                            this.$router.push({name: 'Login'});
                        }
                    }
                }
            },

            async SignUpFacebook({token, becomeOwner = false, redirect = true}) {
                try {
                    this.signInLoading = true
                    var questionsUids = []
                    const response = await this.signUpFaceBookAction({token, questionsUids})
                    if (response.data.access_token && response.data.refresh_token) {
                        this.setSignInState(response)
                    }
                } catch (error) {

                } finally {
                    this.signInLoading = false
                }
            },

            async SignUpGoogle({token, becomeOwner = false, redirect = true}) {
                try {
                    this.signInLoading = true
                    var questionsUids = []
                    const response = await this.signUpGoogleAction({token, questionsUids})
                    if (response.data.access_token && response.data.refresh_token) {
                        this.setSignInState(response)
                    }
                } catch (error) {
                    console.log('error', error)
                } finally {
                    this.signInLoading = false
                }
            },

            facebookSignInPromise() {
                let fb = this.FB
                return new Promise(function (resolve, reject) {
                    fb.login((response) => {
                        if (response.authResponse) {
                            resolve(response.authResponse)
                        } else {
                            reject()
                        }
                    }, {
                        scope: 'email',
                        return_scopes: true
                    });
                })
            },

            async FacebookSignIn({becomeOwner, redirect = true}) {
                let auth = await this.facebookSignInPromise()
                if (auth.accessToken) {
                    await this.SignUpFacebook({
                        token: auth.accessToken,
                        becomeOwner,
                        redirect
                    })
                }
            },
            async GoogleSignIn({becomeOwner, redirect = true}) {
                console.log(`GoogleSignIn:becomeOwner:${becomeOwner} | redirect:${redirect}`)
                let GoogleUser = await this.$gAuth.signIn()
                console.log(GoogleUser)
                await this.SignUpGoogle({
                    token: GoogleUser.getAuthResponse(true).id_token,
                    becomeOwner,
                    redirect
                })
            },

            sdkLoaded(payload) {
                this.isConnected = payload.isConnected;
                this.FB = payload.FB;
                this.loadingFacebookSpinner = true;
            },

            isClickOutOfBlock(blockId, target) {
                return document.getElementById(blockId) == null || !document.getElementById(blockId).contains(target)
            },

            back() {
                this.$router.go(-1);
            },
            async hasLocationPermission() {
                if(navigator.permissions && navigator.permissions.query) {
                    let result = await navigator.permissions.query({name: 'geolocation'});
                    return result.state == 'granted'
                } else {
                    return false
                }
            },
            collectLocationObj(position) {
                return {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                    accuracy: Math.round(position.coords.accuracy),
                    original_date: position.timestamp
                }
            },
            async initFetchLocationFlow (successCallback = null, errorCallback = null) {
                this.sendGpsRequestedAction()
                try {
                    let time = (new Date()).getTime()
                    let allowedDiffSeconds = 30
                    let position = await this.fetchUserLocation(30000)
                    if(time - position.timestamp > allowedDiffSeconds*1000) {
                        this.sendLocationIsOldAction(this.collectLocationObj(position))
                        position = await this.fetchUserLocation(30000)
                        if(time - position.timestamp > allowedDiffSeconds*1000) {
                            this.sendLocationIsOldAction(this.collectLocationObj(position))
                            position = await this.fetchUserLocation(30000)
                        }
                    }
                    let obj = this.collectLocationObj(position)
                    this.sendLocationAction(obj)
                    if(successCallback) successCallback()
                } catch (error) {
                    console.log("error: ", error)
                    let type = ''
                    switch (error.code) {
                        case 1: {
                            type = 'denied'
                            break;
                        }
                        case 2: {
                            type = 'unavailable'
                            break;
                        }
                        case 3: {
                            type = 'timeout'
                            break;
                        }
                    }
                    this.sendLocationErrorAction(`error code: ${error.code} | ${JSON.stringify(error)}`, type)
                    if(errorCallback) errorCallback()
                }
            },
            async sendLocationErrorAction (error, type) {
                let body = {
                    error: error,
                    question_uid: this.question_id,
                    vote_uid: this.currentVote.uid,
                    place_name: this.place_info.place.name,
                    type: type,
                    date: (new Date()).toISOString(),
                    is_special: this.place_info.special_ask_vote_gps,
                }
                try {
                    let response = await this.sendLocationError(body)
                } catch (error) {
                    console.log("Error:", error)
                }
            },
            async sendLocationPopupAllowedAction () {
                let body = {
                    question_uid: this.question_id,
                    vote_uid: this.currentVote.uid,
                    place_name: this.place_info.place.name,
                    date: (new Date()).toISOString(),
                    is_special: this.place_info.special_ask_vote_gps,
                }
                try {
                    let response = await this.sendLocationAllowedPopup(body)
                } catch (error) {
                    console.log("Error:", error)
                }
            },
            async sendLocationPopupAskedAction () {
                let body = {
                    question_uid: this.question_id,
                    vote_uid: this.currentVote.uid,
                    place_name: this.place_info.place.name,
                    date: (new Date()).toISOString(),
                    is_special: this.place_info.special_ask_vote_gps,
                }
                try {
                    let response = await this.sendGpsPopupAsked(body)
                } catch (error) {
                    console.log("Error:", error)
                }
            },
            async sendGpsRequestedAction () {
                let body = {
                    question_uid: this.question_id,
                    vote_uid: this.currentVote.uid,
                    place_name: this.place_info.place.name,
                    date: (new Date()).toISOString(),
                    is_special: this.place_info.special_ask_vote_gps,
                }
                try {
                    let response = await this.sendGpsRequested(body)
                } catch (error) {
                    console.log("Error:", error)
                }
            },
            async sendGpsLoadingPopupHideAction () {
                let body = {
                    question_uid: this.question_id,
                    vote_uid: this.currentVote.uid,
                    place_name: this.place_info.place.name,
                    date: (new Date()).toISOString(),
                    is_special: this.place_info.special_ask_vote_gps,
                }
                try {
                    let response = await this.sendGpsLoadingPopupHide(body)
                } catch (error) {
                    console.log("Error:", error)
                }
            },
            async sendLocationAction (obj) {
                let body = {
                    lat: obj.lat,
                    lng: obj.lng,
                    accuracy: obj.accuracy,
                    date: (new Date()).toISOString(),
                    original_date: (new Date(obj.original_date)).toISOString(),
                    is_special: this.place_info.special_ask_vote_gps,
                }
                try {
                    let response = await this.sendVoteGeolocation({ voteId:this.currentVote.uid, body})
                } catch (error) {
                    console.log("Error:", error)
                }
            },
            async sendLocationIsOldAction (obj) {
                let body = {
                    lat: obj.lat,
                    lng: obj.lng,
                    accuracy: obj.accuracy,
                    date: (new Date()).toISOString(),
                    original_date: (new Date(obj.original_date)).toISOString(),
                    is_special: this.place_info.special_ask_vote_gps,
                }
                try {
                    let response = await this.sendLocationIsOld({ voteId:this.currentVote.uid, body})
                } catch (error) {
                    console.log("Error:", error)
                }
            },
            navToServiceLog(questionUid) {
                window.location.replace(`${location.origin}/r/sl/${questionUid}`)
            },
            navToNewSL(questionUid) {
                window.location.replace(`${location.origin}/questions/${questionUid}/service/log`)
            },
            navToVote(questionUid, force = false) {
                window.location.replace(`${location.origin}/r/rate/${questionUid}/3?force_vote=${force}`)
            },
        }
    };

    window.auth = {}

</script>

<style>

    @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;600;700;800&display=swap');
    @font-face {
      font-family: "Proxima Nova";
      src: url("./../src/assets/fonts/FontsFree-Net-Proxima-Nova-A-W01-Extrabold.ttf");
    }
    @font-face {
      font-family: "Proxima Nova Light";
      src: url("./../src/assets/fonts/FontsFree-Net-Proxima-Nova-Black.otf");
    }


    * {
        font-family: 'Nunito';
        font-weight: 700;
    }

    .md-theme-default body {
        font-size: 1em;
    }

    body b {
        font-weight: 700;
    }

    .md-field .md-count,
    .md-field .md-error,
    .md-field .md-helper-text {
        color: #6D6D6D;
    }

    body .custom-control-label::after {
        width: 20px;
        height: 20px;
    }

    .bm-overlay,
    #app {
        background: #fff;
        min-height: auto;
    }

    h3 {
        margin: 40px 0 0;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #b8b7ad;
    }

    .error_modal {
        height: 140px;
        width: 350px;
        z-index: 99999999;
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        border-radius: 3px;
        padding: 0;
        background-color: #FFFFFF;
        box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.12);
    }

    .error_modal .body {
        color: #424242;
        position: absolute;
        top: 50%;
        max-width: 100%;
        left: 0;
        right: 0;
        padding-left: 10px;
        padding-right: 10px;
        text-align: center;
        transform: translate(-0%, -50%);
    }

    .error_modal .close {
        position: absolute;
        top: 10px;
        right: 10px;
    }

    .error_modal .close img {
        width: 17px;
        height: 17px;
    }

    .v-facebook-login {
        display: none !important;
    }
</style>
